(function(app) {

    app.provider("userApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    service.getUserTransactionGroup = function () {
                        return complianceHubApiGateway.get("/Users/TransactionGroup");
                    };

                    service.getCurrentUser = function() {
                        return complianceHubApiGateway.get("/Users/Current");
                    };

                    service.getContextUserIds = function () {
                        return complianceHubApiGateway.get("/Users/ContextUserIds");
                    };

                    service.getCurrentTransactionGroupUserMember = function () {
                        return complianceHubApiGateway.get("/Users/CurrentUserMember");
                    }

                    service.getTransactionGroupUserMemberForUser = function (userId) {
                        return complianceHubApiGateway.get("/Users/UserMemberForUser/" + userId);
                    }
                    
                    service.getCurrentUserPermissions = function () {
                        return complianceHubApiGateway.get("/Users/CurrentUserPermissions");
                    }

                    service.getTransactionGroupUserMember = function (userMemberId) {
                        return complianceHubApiGateway.get("/Users/UserMember/" + userMemberId);
                    }

                    service.getAllUsers = function() {
                        return complianceHubApiGateway.get("/Users/All");
                    };

                    service.getUsersForDelegateUser = function (userId) {
                        return complianceHubApiGateway.getArray("/Users/" + userId + "/DelegateOfUsers");
                    }

                    service.getAllDelegatesForUser = function (userId) {
                        return complianceHubApiGateway.getArray("/Users/" + userId + "/Delegates");
                    }

                    service.getOnBehalfOfUserPermissions = function (userId) {
                        return complianceHubApiGateway.getArray("/Users/" + userId + "/OnBehalfOfUserPermissions");
                    }

                    service.searchUserEmailAddresses = function (term) {
                        return complianceHubApiGateway.get("/Users/All/Search?q=" + term);
                    }

                    service.get = function(userId) {
                        return complianceHubApiGateway.get("/Users/" + userId);
                    };

                    service.getUserByAuthId = function (authId) {
                        return complianceHubApiGateway.get("/Users/AuthUser/" + authId);
                    };

                    service.addUser = function(user) {
                        return complianceHubApiGateway.post("/Users", user);
                    };

                    service.UpdateUserInformation = function(user) {
                        return complianceHubApiGateway.put("/Users", user);
                    };

                    return service;
                }
            ];
        }
    ]);
})(window.app); // jshint ignore:line